module.exports = __webpack_public_path__ + "img/align_full.c402cf67.svg";